// Browser autoplay policies (Chrome/Edge/Firefox) always allow a media
// element to start MUTED, and allow it to be unmuted afterward without a
// fresh user gesture. So when a normal (audible) play() is rejected by the
// autoplay policy, retry muted before giving up — this is the difference
// between the candidate actually hearing the question and the interview
// silently skipping past it while still recording their answer.
export const playAudioResilient = (audioEl, onGiveUp) => {
  if (!audioEl) return;

  audioEl
    .play()
    .catch((err) => {
      console.error("Audio play error:", err);
      audioEl.muted = true;
      audioEl
        .play()
        .then(() => {
          audioEl.muted = false;
        })
        .catch((mutedErr) => {
          console.error("Audio play error (muted retry failed):", mutedErr);
          onGiveUp?.();
        });
    });
};
